import React from "react";
import { Form, Typography } from "antd";

import { StyledDescriptions } from "../../_common/styles";
import { timeOptionsMap } from "./contstants";
import { formatPrice } from "helperFunctions";

interface Props {
  name: string[];
  currency: string;
}

const Preview: React.FC<Props> = ({ name, currency }) => {
  return (
    <Form.Item noStyle shouldUpdate>
      {({ getFieldValue }) => {
        const value = getFieldValue(name);

        return value ? (
          <StyledDescriptions
            bordered
            column={2}
            title={`Per Time (${timeOptionsMap[value.type]?.label})`}
            layout="vertical"
          >
            <StyledDescriptions.Item style={{ width: "20%" }}>Special Projects</StyledDescriptions.Item>
            <StyledDescriptions.Item>
              <Typography.Text>
                {formatPrice(value.price)} {currency}
              </Typography.Text>
            </StyledDescriptions.Item>
          </StyledDescriptions>
        ) : null;
      }}
    </Form.Item>
  );
};

export default Preview;
